export default "/images/project-genvid-streaming.png";